import { ClockAction } from './clock-action-enum';
import * as moment from 'moment';

export class EmployeeClockAction {
    action: ClockAction | string;
    timestamp: moment.Moment;
    duration?: string;

    constructor(data: any) {
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/shared/models/employee-clock-action.ts